import React from 'react'

// We use slightly modified DomInspector library.
import DomInspector from './dom-inspector/dist/dom-inspector.js';
// import './dom-inspector/dist/dom-inspector.min.js';
// import DomInspector from 'dom-inspector';
// import BorderDrag from '../border-drag';
import { setCustomClass } from 'Functions/get-selector';

/* Import CSS */
import './index.scss'

class Inspector extends React.Component {
	constructor( props ) {
		super( props )

		// this._inspectorActive = false;
		// this._highlightActive = false;
		this._doc = window.frames[ 'stylist_iframe' ].contentDocument;
		this._window = window.frames[ 'stylist_iframe' ].contentWindow;
		this.highlighter = new DomInspector( {
			window: window.frames[ 'stylist_iframe' ].contentWindow,
			doc: this._doc,
			root: this._doc.querySelector( 'body' ),
			theme: 'stylist-theme'
		} );

		this._init();

		// Initiate border-drag-resize functionality.
		// this._borderDrag = new BorderDrag();
	}

	_init = () => {
		if ( this.props.inspectorActive ) {
			this.highlighter.enable();
		}

		this._events();
	}

	_events = () => {
		const self = this;
		// Add click event listener.
		this._doc.addEventListener( 'click', function( evt ) {
			self._select( evt )
		} );
		// this._window.addEventListener( 'scroll', this._scroll );

		// Scroll Continious.
		this._window.addEventListener( 'scroll', this._scroll );

		// Scroll Stop.
		this._window.addEventListener( 'scroll', this._delayedExec( 500, function() {
			this._scrollStop();
		}.bind( this ) ) );
	}

	// Rewrite (before delay expired) callback timeout for scrollStop:
	// https://stackoverflow.com/a/15165205/2506521
	_delayedExec = ( after, fn ) => {
		let timer;
		return function() {
			timer && clearTimeout( timer );
			timer = setTimeout( fn, after );
		};
	}

	_highliterOff = () => {
		// if ( this._highlightActive ) {
		if ( this.props.inspectorActive ) {
			this.highlighter.disable()
			this.props.onInspectorToggle()
			// this._highlightActive = false;
		}
	}

	_highliterOn = () => {
		// if ( ! this._highlightActive ) {
		if ( ! this.props.inspectorActive ) {
			this.highlighter.enable()
			this.props.onInspectorToggle()
			// this._highlightActive = true;
		}
	}

	_scroll = () => {
		// On scroll - disable highlighter.
		// this._highliterOff()
		this.highlighter.disable();
	}

	_scrollStop = () => {
		// On scroll stop - re-enable highlighter.
		// if ( this._inspectorActive ) {
		if ( this.props.inspectorActive ) {
			// this._highliterOn()
			this.highlighter.enable();
		}
	}

	// Element selected for design customization.
	_select = ( evt ) => {
		if ( this.props.inspectorActive ) {
			if ( evt.type !== 'click' ) {
				return true;
			}

			this.highlighter.pause()

			// Selected element.
			const element = this.highlighter.target

			this._selectByEl( element )
		} // End if ( this._inspectorActive ).
	}

	_selectByEl = ( element ) => {
		// Selected element.
		// const element = this.highlighter.target

		if ( element === null ) {
			return;
		}

		// Activate interactive border dragger.
		// this._borderDrag.on();

		// Hover it.
		element.classList.add( 'stlst-selected' );
		// Temporary Stylist ID.
		element.setAttribute( 'data-stylist-id', this._makeId() );

		// Element successfuly selected. Don't need highlighter anymore.
		this._highliterOff()

		// Try to detect a Gutenberg block and add a special dynamic id to it.
		const customClass = setCustomClass( element, this._makeId( 4 ) )
		// Pass data to the parent App component.
		this.props.onElementSelected( element )
	}

	_makeId = ( length = 8 ) => {
		let text = '';
		const possible = 'abcdefghijklmnopqrstuvwxyz';

		for ( let i = 0; i < length; i++ )
			text += possible.charAt( Math.floor( Math.random() * possible.length ) );

		return text;
	}

	componentWillReceiveProps = ( nextProps ) => {
		if ( nextProps.inspectorActive ) {
			this.highlighter.enable()
		} else {
			this.highlighter.disable()
		}

		// Redraw inspector highlighter on responsive mode ON/OFF.
		if ( nextProps.responsiveView !== this.props.responsiveView ) {
			this.highlighter.refreshOverlay();
		}

		if ( nextProps.selectedEl !== this.props.selectedEl &&
			nextProps.selectedEl !== this.highlighter.target &&
			nextProps.selectedEl.classList !== undefined &&
			! nextProps.selectedEl.classList.contains( 'stlst-selected' ) ) {
			this._selectByEl( nextProps.selectedEl )
		}
	}

	render() {
		return null
	}
}

export default Inspector;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/inspector/index.jsx